const VerticalSpacing = ({height}) => {
    return <div style={{height: `${height}px`}}></div>
}

export default VerticalSpacing;